module.exports = __webpack_public_path__ + "img/pending.a21ab49d.gif";